module.exports = __webpack_public_path__ + "static/media/VNPAY.fd59a284.svg";